const en = {
    title: 'Storage',
    description: 'Choose a storage to access your files.',
    open: 'Open storage',
    loading: 'Loading storage…',
    emptyTitle: 'No storage available yet',
    emptyDescription: 'Storage linked to your account will appear here.',
    errorTitle: 'Unable to load storage',
    errorDescription:
        'Check your connection and try again. If the problem persists, sign in again.',
    refresh: 'Refresh',
    retry: 'Try again',
    account: 'Account',
    logout: 'Sign out',
    navigation: 'Main navigation',
    skipToContent: 'Skip to content',
    language: 'Language',
    transfers: 'File transfers',
}

const ru: Record<keyof typeof en, string> = {
    title: 'Хранилища',
    description: 'Выберите хранилище, чтобы открыть свои файлы.',
    open: 'Открыть хранилище',
    loading: 'Загружаем хранилища…',
    emptyTitle: 'Пока нет доступных хранилищ',
    emptyDescription: 'Здесь появятся хранилища, связанные с вашим аккаунтом.',
    errorTitle: 'Не удалось загрузить хранилища',
    errorDescription:
        'Проверьте подключение и попробуйте ещё раз. Если ошибка повторяется, войдите в аккаунт заново.',
    refresh: 'Обновить',
    retry: 'Попробовать ещё раз',
    account: 'Аккаунт',
    logout: 'Выйти',
    navigation: 'Основная навигация',
    skipToContent: 'Перейти к содержимому',
    language: 'Язык',
    transfers: 'Передача файлов',
}

export const storageMessages = { en, ru }
